export interface VaultSyncConfiguration {
  uuid: string;
  folderUuid: string;
  domainUuid: string;
  isActive: boolean;

  // Configuration Bulletins
  syncPayslips: boolean;
  payslipDayOfMonth: number;
  payslipExecutionHour: number;
  payslipExecutionMinute: number;

  // Configuration DSN
  syncDsn: boolean;
  dsnDayOfMonth: number;
  dsnExecutionHour: number;
  dsnExecutionMinute: number;

  // Destinations
  syncToFolderVault: boolean;
  syncToEmployeeVaults: boolean;

  // Dépôt direct
  directDepositToEmployee: boolean;

  // Période
  usePreviousMonth: boolean;

  // Notifications
  notificationEmail?: string;

  // Métadonnées
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateVaultSyncConfigurationDto {
  folderUuid: string;
  domainUuid: string;
  isActive?: boolean;

  // Configuration Bulletins
  syncPayslips?: boolean;
  payslipDayOfMonth?: number;
  payslipExecutionHour?: number;
  payslipExecutionMinute?: number;

  // Configuration DSN
  syncDsn?: boolean;
  dsnDayOfMonth?: number;
  dsnExecutionHour?: number;
  dsnExecutionMinute?: number;

  // Destinations
  syncToFolderVault?: boolean;
  syncToEmployeeVaults?: boolean;

  // Dépôt direct
  directDepositToEmployee?: boolean;

  // Période
  usePreviousMonth?: boolean;

  // Notifications
  notificationEmail?: string;
}

export interface UpdateVaultSyncConfigurationDto {
  isActive?: boolean;

  // Configuration Bulletins
  syncPayslips?: boolean;
  payslipDayOfMonth?: number;
  payslipExecutionHour?: number;
  payslipExecutionMinute?: number;

  // Configuration DSN
  syncDsn?: boolean;
  dsnDayOfMonth?: number;
  dsnExecutionHour?: number;
  dsnExecutionMinute?: number;

  // Destinations
  syncToFolderVault?: boolean;
  syncToEmployeeVaults?: boolean;

  // Dépôt direct
  directDepositToEmployee?: boolean;

  // Période
  usePreviousMonth?: boolean;

  // Notifications
  notificationEmail?: string;
}

// Form state for UI
export interface VaultSyncConfigurationFormState {
  isActive: boolean;

  // Configuration Bulletins
  syncPayslips: boolean;
  payslipDayOfMonth: number;
  payslipExecutionHour: number;
  payslipExecutionMinute: number;

  // Configuration DSN
  syncDsn: boolean;
  dsnDayOfMonth: number;
  dsnExecutionHour: number;
  dsnExecutionMinute: number;

  // Destinations
  syncToFolderVault: boolean;
  syncToEmployeeVaults: boolean;

  // Dépôt direct
  directDepositToEmployee: boolean;

  // Période
  usePreviousMonth: boolean;

  // Notifications
  notificationEmail: string;
}

// Manual sync types
export type DepositMode = 'grouped' | 'individual';

export interface ManualSyncRequest {
  folderUuid: string;
  syncPayslips: boolean;
  syncDsn: boolean;
  year: number;
  month: number;
  depositMode?: DepositMode;
  employeeUuids?: string[];
  directDepositToEmployee?: boolean;
}

export interface TransferToEmployeeRequest {
  employeeUuids?: string[];
}

export interface BulkTransferToEmployeeRequest {
  documentUuids: string[];
  employeeUuids?: string[];
}

export interface TransferResult {
  success: boolean;
  transferredCount: number;
  errors: string[];
}

export interface BulkTransferResult {
  success: boolean;
  totalTransferred: number;
  errors: string[];
}

export interface ManualSyncResult {
  success: boolean;
  payslipsSynced: number;
  dsnSynced: boolean;
  vaultsUpdated: string[];
  errors: string[];
  details: {
    folderVaultId?: string;
    employeeVaultIds?: string[];
    documentsCreated: number;
    employeesProcessed: number;
    employeesWithVault: number;
    employeesWithoutVault: number;
  };
}

export interface AvailablePeriod {
  year: number;
  month: number;
  hasPayslips: boolean;
  hasDsn: boolean;
}

// Default values
// [2026-05-13] isActive/syncPayslips/syncDsn par défaut à false (opt-in
// explicite). Avant : valeurs à true affichées dans l'UI faisaient croire
// que le dépôt auto était activé partout. Désormais, l'utilisateur doit
// activer manuellement chaque option pour chaque dossier concerné.
// Les jours (5, 10) et heures (14h00) restent suggérés en cas d'activation.
export const DEFAULT_VAULT_SYNC_CONFIG: VaultSyncConfigurationFormState = {
  isActive: false,
  syncPayslips: false,
  payslipDayOfMonth: 5,
  payslipExecutionHour: 14,
  payslipExecutionMinute: 0,
  syncDsn: false,
  dsnDayOfMonth: 10,
  dsnExecutionHour: 14,
  dsnExecutionMinute: 0,
  syncToFolderVault: true,
  syncToEmployeeVaults: false,
  directDepositToEmployee: true,
  usePreviousMonth: true,
  notificationEmail: '',
};
